import { createClient } from '@supabase/supabase-js'

// Obtém as variáveis de ambiente configuradas no .env.local
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Verifica se as variáveis foram carregadas
if (!supabaseUrl || !supabaseAnonKey) {
  console.error("Erro: Variáveis de ambiente Supabase (REACT_APP_SUPABASE_URL e REACT_APP_SUPABASE_ANON_KEY) não encontradas. Verifique seu arquivo .env.local e reinicie o servidor de desenvolvimento se necessário.");
}

// Cria e exporta o cliente Supabase
export const supabase = createClient(supabaseUrl, supabaseAnonKey)
